import script from "./LuceWordmark.vue?vue&type=script&setup=true&lang=js"
export * from "./LuceWordmark.vue?vue&type=script&setup=true&lang=js"

import "./LuceWordmark.vue?vue&type=style&index=0&id=0577cd7f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0577cd7f"]])

export default __exports__